import type { IconProps } from './typesIcons'

export function CrossSellPlusIcon({
  width = 28,
  height = 28,
  color = '#001018',
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 12V0H16V12H28V16H16V28H12V16H0V12H12Z" fill={color} />
    </svg>
  )
}
